import {faCartShopping} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { cartSelector, updateDataThunk } from "../../redux/slices/cartSlice";
import {Link} from "react-router-dom";

const CartBar = () => {

    const dispatch = useDispatch();
    const cart = useSelector(cartSelector);
    const [cartTotal, setCartTotal] = React.useState('');

    React.useEffect(() => {
        setCartTotal(cart.total);
    }, [cart])

    React.useEffect(() => {
        dispatch(updateDataThunk({}));
    }, [])

    return <Link to={'/cabinet/cart'}>
        <FontAwesomeIcon size={'xl'} icon={faCartShopping} />
        <span style={{paddingLeft: '0.5rem'}}>Корзина ({cartTotal})</span>
    </Link>
}

export default CartBar;
